import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import _ from 'lodash';
import React from 'react';
import SelectedStar from '../../../../assets/star_full.png';
import UnselectedStar from '../../../../assets/star_empty.png';

const MDStarRateView = ({
  value,
  totalValues,
  minimumValue,
  title,
  titleStyle,
  onSelectValue,
  starStyle,
  unselectedStarStyle,
  starContainerStyle,
  clickable = true
}) => {
  const getContent = (isSelected) =>
    isSelected ? (
      <img alt="evaluation" src={SelectedStar} style={{ ...starStyle, width: 20 }} />
    ) : (
      <img alt="evaluation" src={UnselectedStar} style={{ ...unselectedStarStyle, width: 20 }} />
    );

  return (
    <div style={{ ...starContainerStyle }}>
      {title && <h4 style={{ margin: 0, marginBottom: 10, ...titleStyle }}>{title}</h4>}
      {_.times(totalValues, (currentValue) => {
        const isSelected = currentValue + 1 <= value || currentValue + 1 === minimumValue;
        return clickable ? (
          <IconButton
            style={{ padding: 6 }}
            key={currentValue}
            onClick={onSelectValue ? () => onSelectValue(currentValue + 1) : null}
          >
            {getContent(isSelected)}
          </IconButton>
        ) : (
          <Icon
            key={currentValue}
            style={{ display: 'flex', alignItems: 'baseline', padding: 6, height: 'auto', width: 'auto' }}
          >
            {getContent(isSelected)}
          </Icon>
        );
      })}
    </div>
  );
};

export default MDStarRateView;
